import { ProLayoutProps } from '@ant-design/pro-components';
import ErrorBoundary from '../src/pages/ErrorBoundary';
/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#5F49E5',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Intradesk系统',
  logo: '@/assets/logo.svg',
  iconfontUrl: '',
  token: {
    colorPrimary: '#5F49E5',
    sider: {
      colorTextMenu: '#2F3133',
      colorMenuBackground: '#ffffff',
      colorTextMenuSelected: '#ffffff',
      colorTextMenuItemHover: '#5F49E5',
      colorTextMenuActive: '#5F49E5',
      colorTextMenuSecondary: '#ffffff',
      colorBgMenuItemSelected: '#5F49E5',
      colorBgMenuItemActive: '#ECE9FC',
      colorBgMenuItemHover: '#ECE9FC',
    },
    header: {
      // colorBgHeader: '#020566',
      // colorBgHeader: '#10159d',
      colorBgHeader: '#ffffff',
      // colorBgHeader: '#077aff',
      colorHeaderTitle: '#000000',
    },
    pageContainer: {
      paddingInlinePageContainerContent: 16,
      paddingBlockPageContainerContent: 16,
    },
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  ErrorBoundary,
};

export default Settings;
